"use client";

import * as React from "react";
import { useLocale, type Lang } from "@/app/[lang]/providers/LocaleProvider";
import { useSiteSettings } from "@/hooks/useSiteSettings";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/shadcn/dialog";
import { VisuallyHidden } from "@radix-ui/react-visually-hidden";

type LocalizedValue = string | Partial<Record<Lang, string>> | null | undefined;
type PopupSettings = {
  popup_title?: LocalizedValue;
  popup_title_en?: string | null;
  popup_title_id?: string | null;
  popup_desc?: LocalizedValue;
  popup_desc_en?: string | null;
  popup_desc_id?: string | null;
};

function resolveLocalizedPopupField(
  settings: PopupSettings | undefined,
  field: "popup_title" | "popup_desc",
  locale: Lang
) {
  if (!settings) return "";

  const suffixedValue = settings[`${field}_${locale}`];
  if (suffixedValue) return suffixedValue;

  const value = settings[field];
  if (typeof value === "string") return value;
  return value?.[locale] ?? value?.id ?? value?.en ?? "";
}

export default function HomepagePopup() {
  const locale = useLocale();
  const { data } = useSiteSettings(locale);
  const [open, setOpen] = React.useState(false);

  const settings = data?.data;
  const popupTitle = resolveLocalizedPopupField(settings, "popup_title", locale);
  const popupDesc = resolveLocalizedPopupField(settings, "popup_desc", locale);

  React.useEffect(() => {
    if (!settings?.popup_is_active) return;
    const hasPopupContent =
      settings.popup_image || popupTitle || popupDesc;
    if (!hasPopupContent) return;

    setOpen(true);
  }, [popupDesc, popupTitle, settings?.popup_image, settings?.popup_is_active]);

  if (!settings?.popup_is_active) return null;

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="sm:max-w-xl p-0 overflow-hidden">
        <VisuallyHidden><DialogTitle>{popupTitle || "Popup"}</DialogTitle></VisuallyHidden>
        {settings.popup_image && (
          <img
            src={settings.popup_image}
            alt={settings.popup_image_alt ?? ""}
            className="w-full h-auto block"
          />
        )}
        {/* {(popupTitle || popupDesc) && (
          <div className="p-6 space-y-3">
            {popupTitle && (
              <DialogHeader>
                <DialogTitle>{popupTitle}</DialogTitle>
              </DialogHeader>
            )}
            {popupDesc && (
              <div
                className="text-sm text-muted-foreground prose max-w-none"
                dangerouslySetInnerHTML={{ __html: popupDesc }}
              />
            )}
          </div>
        )} */}
      </DialogContent>
    </Dialog>
  );
}
